import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import useRoles from 'hooks/useRoles';
import useFHRequest from 'hooks/useFHRequest';
import useWorkKey from 'hooks/useWorkKey';

import WorkList from 'components/WorkList';
import { WorkItemType } from 'components/WorkListItem';

function SupportTeamActionsTitle() {
    return (
        <Stack>
            <Typography level="title-lg">
                Support Team Actions
            </Typography>
            <Typography level="body-xs">
                Someone needs your help
            </Typography>
        </Stack>
    );
}

const SupportTeamActions = observer(() => {
    const { rolesNames } = useRoles();
    const workKey = useWorkKey();
    const { fetchListSupportAttention } = useFHRequest();
    const [requests, setRequests] = useState<WorkItemType[]>([]);
    const [loading, setLoading] = useState(false);
    if (!rolesNames.includes('support'))
        return null;

    useEffect(() => {
        if(!workKey) return;
        setLoading(true);
        console.log('fetchListSupportAttention');
        fetchListSupportAttention(workKey)
            .then((res) => {
                setLoading(false);
                setRequests(res.sort((a, b) => a.date_created < b.date_created ? 1 : -1));
                console.log('fetchListSupportAttention', res);
                console.log(res);
            })
    }, [fetchListSupportAttention, workKey]);

    return (

    <WorkList
               title={<SupportTeamActionsTitle />}
               items={requests}
               loading={loading}
               paged={false} />

    );
});
export default SupportTeamActions;
